import { getInitialState, getPath } from "../../utils";
import ActionTypes from "../actions/ActionTypes";

const initialState = {
  qcDetails: {},
  qcRejectionReasons: [],
  currentActiveFeId: "",
  qcDocTypes: [],
};

export default function (state = initialState, action) {
  switch (action.type) {
    case ActionTypes.SET_QC_DETAILS:
      return setQcDetails(state, action);
    case ActionTypes.SET_QC_ADDITIONAL_DATA:
      return setQcAdditionalData(state, action);
    case ActionTypes.SET_CURRENT_FEID:
      return setCurrentFeId(state, action);
    case ActionTypes.RESET_STATE_QC:
      return resetStateQc(state, action);
    default:
      return state;
  }
}

const setQcDetails = (state, action) => {
  return {
    ...state,
    qcDetails: action.payload,
  };
};

const setQcAdditionalData = (state, action) => {
  return {
    ...state,
    qcRejectionReasons: action.payload.reasons,
    qcDocTypes: action.payload.doc_types,
  };
};

const setCurrentFeId = (state, action) => {
  return {
    ...state,
    currentActiveFeId: action.payload.feid,
  };
};

const resetStateQc = (state, action) => {
  // reset specific key if given else reset complete state
  if (action.payload.state) {
    return {
      ...state,
      [action.payload.state]: getInitialState(
        initialState,
        action.payload.state
      ),
    };
  } else {
    return initialState;
  }
};
